import { Grid, Typography } from "@mui/material";

type AlarmConsultContentProps = {
  children: React.ReactNode;
  title: string;
};

export function AlarmConsultContent({
  children,
  title,
}: AlarmConsultContentProps) {
  return (
    <>
      <Grid container sx={{ rowGap: "20px" }}>
        <Grid item xs={12} display={"flex"}>
          <Typography sx={{ paddingTop: "16px" }}>{title}</Typography>
        </Grid>
        {children}
      </Grid>
    </>
  );
}
